<template>
    <div class="demo-reel-feedback">
        <div class="form-group">
            <div class="feedback">
                <div>
                    <textarea v-model="feedback.text" :placeholder="'Please provide feedback for ' + student.firstName + ' ' + student.lastName + '\'s progress this week, which they will review'"></textarea>
                </div>
                <div>
                    <dropzone id="feedbackFiles" ref="feedbackFiles" url="#" v-bind:use-custom-dropzone-options="true" v-bind:thumbnail-height="0" v-bind:dropzone-options="dropzoneOptions">
                    </dropzone>
                </div>
            </div>
            <button @click.prevent="submitFeedback()" class="btn btn-success">Send Feedback</button>
        </div>
    </div>
</template>
<script>
import aws from '../../services/aws';
import checkins from '../../services/checkins';

import Dropzone from 'vue2-dropzone';
import toastr from 'toastr';

export default {
    props: ['checkin', 'student', 'checkinId', 'alertId'],
    data() {
        return {
            feedback: {
                text: null,
                files: []
            },
            dropzoneOptions: {
                autoProcessQueue: false,
                uploadMultiple: true,
                addRemoveLinks: true,
                dictDefaultMessage: 'Drag and drop images or MP4 video feedback'
            },
        }
    },
    components: {
        Dropzone
    },
    mounted() {
    },
    methods: {
        isAllowed(file) {
            const imageExtensions = ['jpg', 'jpeg', 'gif', 'png', 'mp4'];
            return imageExtensions.includes(file.split('.').pop());
        },
        async submitFeedback() {
            var self = this;

            if (this.$refs.feedbackFiles.dropzone.files.length > 0) {

                const bucket = 'tto-mentor-checkins';

                for (let file of this.$refs.feedbackFiles.dropzone.files) {

                    if (isAllowed(file.name)) {

                        let fragments = file.name.split('.');
                        fragments[0] = fragments[0] + '_' + Math.floor(Math.random() * (999 - 100 + 1) + 100);
                        let filename = fragments.join('.');
                        const signature = await aws.signature(file, filename, bucket);
                        const presigned = await aws.getPresignedUrl(self, bucket, filename, 'putObject');
                        const upload = await aws.upload(file, filename, signature, bucket, presigned.data);
                        this.feedback.files.push(upload.url);
                    } else {
                        toastr.error('Incorrect format for file ' + file.name);
                    }

                }

            }

            if (!this.feedback.text && this.feedback.files.length === 0) {
                toastr.error('Please add either text or video feedback');
                return;
            }

            let feedback = this.feedback;
            feedback.demoReelUpdateId = this.checkin.demo_reel_update.id;
            feedback.studentId = this.student.id;
            feedback.week = this.checkin.week;

            checkins.submitFeedback(feedback).then(async (response) => {
                if (response.success === true) {
                    toastr.success('Feedback sent')
                    await this.$parent.getGroup();
                } else {
                    toastr.error(response.message);
                }
            });

        }
    },
    computed: {

    }
}

</script>
<style lang="scss">
.demo-reel-feedback {
    .dropzone {
        border: none;
        background: #212222 !important;
        color: #b0b0b0;
    }
}

</style>
<style lang="scss" scoped>
.work {
    display: flex;
    flex-wrap: wrap;

    li {
        border: none;
        display: flex;
        padding: 1rem;
        align-items: center;
        justify-content: center;
        width: 25%;
    }
}

button {
    margin-left: 1rem;
}

.feedback {
    padding: 0;
    display: flex;

    &>div {
        padding: 1rem;
    }

    div:first-child {
        width: 66.6666%;
    }

    div:last-child {
        width: 33.3333%;
    }
}

textarea {
    height: 150px;
    background: #212222 !important;
    width: 100%;
    color: #b0b0b0;
    padding: 10px;
    border: none !important;

}

</style>



// WEBPACK FOOTER //
// DemoReelFeedback.vue?17c3477d